import { ZodiacScorpioIcon } from './ZodiacScorpioIcon';

/**
 * author: Michael Richins
 * id 0AEE35B6-4A9F-422A-BCC8-395174DCBA71
 * name zodiac-scorpio
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/zodiac-scorpio.svg
 * tags
 */
export const HoroscopeScorpioIcon = ZodiacScorpioIcon;
export default HoroscopeScorpioIcon